import moment from 'moment-timezone';

export const getIsSame = (str1, str2, unit) => {
  const date1 = moment(str1).format('YYYY-MM-DD');
  const date2 = moment(str2).format('YYYY-MM-DD');

  return moment(date1).isSame(date2, unit);
};
